import { IconCheck } from "components/Icons";
import styles from "./CheckList.module.css";

export const CheckListWrapper = ({ items, primary }) => (
  <CheckList
    title={primary.title_checklist}
    items={items.map(({ list_item }) => list_item)}
  />
);

export const CheckList = ({ title, items }) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <ul className={styles.list}>
      {items.map((item) => (
        <li key={item}>
          <IconCheck />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </div>
);
